import { createObjectUrl } from '../../../files';
import type { PreviewGalleryImage } from '../../types';

export const getPreviewImage = async ({
  file,
  status,
  feedbackMessages,
  message,
  disableDelete,
}: {
  file: File;
  status: PreviewGalleryImage['status'];
  feedbackMessages?: string[];
  message?: string;
  disableDelete?: boolean;
}): Promise<PreviewGalleryImage> => {
  return {
    disableDelete,
    feedbackMessages,
    message,
    src: createObjectUrl(file),
    status,
  };
};
